import { create } from 'zustand';

import type { GrowthCreateGoalRequest } from '../../data-contract/growth';

export type RecommendationDraft = Omit<GrowthCreateGoalRequest, 'share'>;

export type RecommendationOutcome = 'kept-private' | 'sent';

type RecommendationDraftsState = {
    readonly drafts: Readonly<Record<string, RecommendationDraft>>;
    readonly outcomes: Readonly<Record<string, RecommendationOutcome>>;
    readonly saveDraft: (recommendationId: string, draft: RecommendationDraft) => void;
    readonly settle: (recommendationId: string, outcome: RecommendationOutcome) => void;
};

// Shared between the onboarding wizard and the new-goal tile, which render in different trees.
export const useRecommendationDrafts = create<RecommendationDraftsState>((set) => ({
    drafts: {},
    outcomes: {},
    saveDraft: (recommendationId, draft) =>
        set((state) => ({ drafts: { ...state.drafts, [recommendationId]: draft } })),
    settle: (recommendationId, outcome) =>
        set((state) => ({ outcomes: { ...state.outcomes, [recommendationId]: outcome } })),
}));
